export default __webpack_public_path__ + "static/media/juego rio 2-23.222c1da0.png";